 
 
 
 
 
 
/**
 * @ignore
 * Objects of this class should contain shared routing information. Currently this information consists of start and
 * end points but it might be extended in the future by waypoints. Instances of this class should be created for each
 * map.
 */
/* jshint nomen:false */
define(['leaflet', '../utils', './routing'], function(L, utils, routing) {
    'use strict';

    var pointProperties = ['startPoint', 'endPoint'];
    var otherProperties = ['jsonRoute'];
    var properties = pointProperties.concat(otherProperties);
    var EVENTS = {
        PROPERTY_VALUE_CHANGED: 'tomtom.propertyvaluechange'
    };
    var RoutingContext;

    function isPointProperty(property) {
        return pointProperties.indexOf(property) !== -1;
    }

    function propertyHandlerInitializer(property) {
        this[property] = function(propValue) {
            var previousValue, currentValue;
            if (propValue !== undefined) {
                previousValue = this['_' + property];
                currentValue = isPointProperty(property) ? utils.convertToLatLng(propValue) : propValue;
                this['_' + property] = currentValue;
                if (isPointProperty(property)) {
                    this._calculateRouteIfPossible();
                }

                this.fire(EVENTS.PROPERTY_VALUE_CHANGED,
                    {name: property, currentValue: currentValue, previousValue: previousValue});
                return previousValue;
            } else {
                return this['_' + property];
            }
        };
    }

    RoutingContext = L.Evented.extend({
        initialize: function() {
            properties.forEach(propertyHandlerInitializer, this);
        },
        _calculateRouteIfPossible: function() {
            var start,
                end,
                startLocation,
                endLocation,
                locations;

            start = this.startPoint();
            end = this.endPoint();
            if (!start || !end) {
                return;
            }

            startLocation = start.lat + ',' + start.lng;
            endLocation = end.lat + ',' + end.lng;
            locations = startLocation + ':' + endLocation;

            routing().locations(locations).go().then(this.jsonRoute.bind(this));
        }
    });

    RoutingContext.Events = EVENTS;

    return RoutingContext;
});



// WEBPACK FOOTER //
// ./services/routing/routingContext.js